import { render } from "./CompanyDaysOff.vue?vue&type=template&id=80d382b8&scoped=true"
import script from "./CompanyDaysOff.vue?vue&type=script&lang=js"
export * from "./CompanyDaysOff.vue?vue&type=script&lang=js"

import "./CompanyDaysOff.vue?vue&type=style&index=0&id=80d382b8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80d382b8"]])

export default __exports__